import React, { useEffect, useState } from "react";
import MuiButton from "Components/MuiButton/MuiButton";
import {
  Dialog,
  DialogActions,
  DialogContent,
  List,
  ListItem,
  ListItemIcon,
  ListItemSecondaryAction,
  ListItemText,
} from "@material-ui/core";
import Translator from "Languages/Utility/Translator";
import MuiIconButton from "Components/MuiIconButton/MuiIconButton";
import Grid from "@material-ui/core/Grid";
import MuiRadioGroup from "Components/MuiRadioGroup/MuiRadioGroup";
import MuiCheckBoxGroup from "Components/MuiCheckboxGroup/MuiCheckboxGroup";
import MuiAutoComplete from "Components/MuiAutoComplete/MuiAutoComplete";
import useScript, { useSetState } from "Helpers/Hooks";
import { useSelector } from "react-redux";
import { read } from "Helpers/LocalStorage";
import FactorService from "Services/http/endpoints/factor/FactorService";
import StatusHandler from "Helpers/StatusHandler";
import { convertGroups } from "Constants/Constants";
import UntiBarService from "Services/http/endpoints/design/UntiBarService";
import showNotify from "Helpers/Notify";
import { ReactSVG } from "react-svg";
import ConvertIcon from "Assets/svg/icon/convert.svg";
import DeleteIcon from "Assets/svg/icon/delete.svg";
import { ACTIVE_SILENT_DRAWER } from "Stores/actionTypes";
import { useDispatch } from "react-redux";
import { useTheme } from '@material-ui/core/styles';
import * as Icons from 'react-bootstrap-icons';

function ItemConversion({ selectUnits }) {
  const { direction } = useTheme();
  const { selectedProject, selectedUnitCount } = useSelector((state) => ({
    selectedProject: state.project.selectedProject,
    selectedUnitCount: state.design.selectedUnitCount,
  }));
  const [openDialog, setOpenDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  const [convertList, setConvertList] = useState([]);
  const [unitConvertInfo, setUnitConvertInfo] = useState(null);
  const [showSelect, setShowSelect] = useState(true);
  const dispatch = useDispatch();

  const [controls, setControls] = useSetState({
    convertGroup: {
      type: "radio",
      value: null,
      items: null,
      col: {
        xs: 12,
        sm: 12,
      },
    },
    convertProfile: {
      type: "checkbox",
      items: [
        { value: true, label: "پروفیل", key: "CheckProfile" },
        { value: false, label: "یراق", key: "CheckFitting" },
        { value: false, label: "شیشه", key: "CheckGlass" },
        { value: false, label: "توری", key: "CheckNet" },
      ],
      col: {
        xs: 12,
        sm: 12,
      },
    },
    convertFrom: {
      type: "select",
      selectItems: [],
      value: "",
      validation: null,
      col: {
        xs: 12,
        sm: 12,
      },
    },
    convertTo: {
      type: "select",
      selectItems: [],
      value: "",
      validation: null,
      col: {
        xs: 12,
        sm: 12,
      },
    },
  });

  const handleDialog = () => setOpenDialog(!openDialog);

  const onEnter = async () => {
    try {
      setLoading(true);
      const data = {
        KeyGroup: read("groupKey"),
        KeyUser: read("userKey"),
        ListUnitId: selectUnits,
        CheckAll: false,
        IdProject: selectedProject.Id,
      };
      const response = await FactorService.postInfoUnitConvert(data);
      setUnitConvertInfo(response.data.Value);
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  }

  const autoCompleteHandler = async (e, value) => {
    const controlName = e.target.id.split("-")[0];
    setControls({ [controlName]: { value: value } });
    if (controlName === "convertFrom") {
      await getToOptions(value);
    }
  }

  const getToOptions = async (selectedValue) => {
    try {
      setLoading(true);
      const { Group } = selectedValue;
      let response = null;
      if (Group === 1) {
        const params = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          IdTemplate: selectedValue.Id,
          Type: selectedValue.TypeTemplate,
        };
        response = await FactorService.getTemplateForConvert(params);
      }
      if (Group === 2) {
        const params = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          IdGlass: selectedValue.Id,
        };
        response = await FactorService.getGlassForConvert(params);
      }
      if (Group === 3) {
        const params = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          IdNet: selectedValue.Id,
        };
        response = await FactorService.getNetForConvert(params);
      }
      if (Group === 4) {
        const params = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          IdPop: selectedValue.Id,
        };
        response = await FactorService.getPopForConvert(params);
      }
      if (Group === 5) {
        const params = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          Id: selectedValue.Id,
        };
        response = await FactorService.getProfileForConvert(params);
      }
      if (response) {
        let err = StatusHandler(response);
        if (!err.isFail) {
          const data = response.data.Value;
          const toOptions = data.map((item) => {
            return {
              ...item,
              value: item.Id,
              label: item.Name,
            };
          });
          setControls({ convertTo: { selectItems: toOptions } });
          setControls({ convertTo: { value: toOptions[0] } });
        }
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  }

  const onFinish = async (e) => {
    e.preventDefault();
    setLoading(true);
    let update = convertList.map((item) => {
      delete item.name;
      delete item.from;
      delete item.to;
      return item;
    });
    try {
      const data = {
        KeyGroup: read("groupKey"),
        KeyUser: read("userKey"),
        // ListUnitId: selectUnits,
        ParamConvert: update,
        ProjectIdSelected:  selectedProject.Id
      };
      const response = await UntiBarService.ConvertUnitAction(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        if(response.data.Value.length !== 0) {
          let list = response.data.Value;
          const unitId = window.location.pathname.split("/design/unit/");
          const reloadId = list[0].Id;
          if(unitId.length > 1 && +unitId[1] === reloadId) {
            let f = list.slice(0, 1);
            list.splice(0, 1);
            list = list.concat(f);
            dispatch({
              type: ACTIVE_SILENT_DRAWER,
              list: list,
              active: true,
            })
          } else {
            dispatch({
              type: ACTIVE_SILENT_DRAWER,
              list: list,
              active: true,
            })
          }
        } else {
          console.log('Convert is ok, but exist no item for change');
        }
        showNotify({
          text: "تبدیل یونیت مورد نظر با موفقیت انجام شد",
          customClass: "success",
        });
        setConvertList([]);
        // window.location.reload();
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
    setLoading(false);
    handleDialog();
  };

  const onChangeRadio = (name, key, value) => {
    setControls({ [name]: { value: value } });
    setControls({ convertFrom: { value: "" } });
    setControls({ convertTo: { value: "" } });
    if (value.value === 1) {
      setShowSelect(true);
    } else {
      setShowSelect(false);
    }
  };

  const onChangeCheckbox = (e, name, index) => {
    const items = controls[name].items;
    items[index] = { ...items[index], value: e.currentTarget.checked };
    setControls({ [name]: { items: items } });
  };
  
  const onAddToList = () => {
    setLoading(true);
    const newList = [...convertList];
    const checkboxes = controls.convertProfile.items.reduce(
      (obj, item) => ({ ...obj, [item.key]: item.value }),
      {}
    );
    const obj = {
      ...checkboxes,
      Group: controls.convertFrom.value.Group,
      IdAz: controls.convertFrom.value.value,
      IdBe: controls.convertTo.value.value,
      TypeTemplate: controls.convertFrom.value.TypeTemplate,
      name: controls.convertGroup.value.label,
      from: controls.convertFrom.value.Name,
      to: controls.convertTo.value.Name,
    };
    setControls({ convertFrom: { value: "" } });
    setControls({ convertTo: { value: "" } });
    newList.push(obj);
    setConvertList(newList);
    setLoading(false);
  };

  const onDelete = async (list) => {
    const newList = convertList.filter(
      (item) => item.IdAz !== list.IdAz && item.IdBe !== list.IdBe
    );
    setConvertList(newList);
  };
  
  const onGetOptionDisabled = (option, key) => {
    const list = [...convertList];
    if (key === "convertFrom") {
      return list.some((item) => item.IdAz === option.value);
    }
  };

  useEffect(() => {
    if (unitConvertInfo) {
      setLoading(true);
      const filterGroups = convertGroups.filter((item) => {
        return unitConvertInfo.some((f) => {
          return f.Group === item.value;
        });
      });
      setControls({ convertGroup: { value: filterGroups[0] } });
      setControls({ convertGroup: { items: filterGroups } });
      setLoading(false);
    }
  }, [unitConvertInfo]);

  useEffect(() => {
    (async () => {
      if (controls.convertGroup.value) {
        setLoading(true);
        const filterFrom = unitConvertInfo.filter(
          (item) => item.Group === controls.convertGroup.value?.value
        );
        const fromOptions = filterFrom.map((item) => {
          return {
            ...item,
            value: item.Id,
            label: item.Name,
          };
        });
        setControls({ convertFrom: { selectItems: fromOptions, value: fromOptions[0] } });
        await getToOptions(fromOptions[0]);
        setLoading(false);
      }
    })();
  }, [controls.convertGroup]);

  return (
    <>
      <MuiIconButton
        className="warning-fill"
        icon={<Icons.ArrowLeftRight size={17}/>}
        title={<Translator id={"unit_convert2"} />}
        onClick={handleDialog}
        disabled={selectedUnitCount === 0}
      />
      <Dialog
        dir={direction}
        open={openDialog}
        onClose={handleDialog}
        onEnter={onEnter}
        fullWidth
        maxWidth="sm"
      >
        <div className="dialogHeader">
          <p>
            <Translator id='unit_convert2' noSpan />
          </p>
        </div>
        <DialogContent>
          <Grid container spacing={2}>
            {Object.keys(controls).map((key, index) => {
              return (
                <Grid item sm={controls[key].col.sm} xs={controls[key].col.xs} key={key + index}>
                  {
                    (controls[key].type === "radio" && controls[key].value) &&
                    <MuiRadioGroup
                      label={<Translator id={key} />}
                      name={key}
                      value={controls[key].value}
                      items={controls[key].items}
                      labelKey={controls[key].labelKey}
                      valueKey={controls[key].valueKey}
                      onChange={onChangeRadio}
                      className="horizontalRadio"
                    />
                  }
                  {
                    (showSelect && controls[key].type === "checkbox") &&
                    <MuiCheckBoxGroup
                      label={<Translator id={key} />}
                      name={key}
                      value={controls[key].value}
                      items={controls[key].items}
                      onChange={onChangeCheckbox}
                      className="horizontalCheckbox"
                    />
                  }
                  {
                    controls[key].type === "select" &&
                    <MuiAutoComplete
                      getOptionDisabled={(option) => onGetOptionDisabled(option, key)}
                      disabled={!controls.convertFrom.value.value && key === "convertTo"}
                      options={controls[key].selectItems}
                      label={<Translator id={key} />}
                      value={controls[key].value}
                      id={key}
                      onChange={autoCompleteHandler}
                    />
                  }
                </Grid>
              );
            })}
            <Grid item xs={12} className="mb-2">
              <MuiButton
                loading={loading}
                disabled={!controls.convertFrom.value.value}
                color="primary"
                title={<Translator id="ezafe_be_list" />}
                onClick={onAddToList}
                className="m-0"
              />
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <List dense={true}>
              {convertList.map((item, index) => {
                return (
                  <ListItem key={`convert-list-${index + 1}`} className="convert-list">
                    <ListItemText
                      primary={
                        <>
                          <Icons.ArrowLeftRight size={15}/>
                          {item.name}
                        </>
                      }
                      secondary={
                        <>
                          <span className="row-head">{"تبدیل از"}</span>
                          <span>{item.from}</span>
                          <span className="row-head">{"به"}</span>
                          <span>{item.to}</span>
                        </>
                      }
                    />
                    <ListItemSecondaryAction>
                      <MuiIconButton
                        icon={<Icons.Trash3 size={17} />}
                        className="danger-fill"
                        onClick={() => onDelete(item)}
                      />
                    </ListItemSecondaryAction>
                  </ListItem>
                );
              })}
            </List>
          </Grid>
        </DialogContent>
        <DialogActions>
          <MuiButton
            color="primary"
            onClick={onFinish}
            disabled={convertList.length === 0}
            title={<Translator id="button_save" />}
          />
          <MuiButton
            onClick={handleDialog}
            title={<Translator id="enseraf" />}
          />
        </DialogActions>
      </Dialog>
    </>
  );
}

export default ItemConversion;
